function initBenefitTestimonialsSwiper(container) {
  if (container.dataset.swiperInit) return;
  container.dataset.swiperInit = '1';

  let swiper = null;

  function handleSwiper() {
    if (window.innerWidth < 1024 && !swiper) {
      swiper = new Swiper(container, {
        slidesPerView: 1.1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        watchOverflow: true,
        pagination: false,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        a11y: {
          prevSlideMessage: 'Previous testimonial',
          nextSlideMessage: 'Next testimonial',
          firstSlideMessage: 'This is the first testimonial',
          lastSlideMessage: 'This is the last testimonial',
        }
      });
    } else if (window.innerWidth >= 1024 && swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
  }

  handleSwiper();

  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleSwiper, 250);
  });
}

function initAllBenefitTestimonials() {
  document.querySelectorAll('.benefit-testimonials-swiper:not([data-swiper-init])').forEach(initBenefitTestimonialsSwiper);
}

if (document.readyState === 'complete') {
  initAllBenefitTestimonials();
} else {
  window.addEventListener('load', initAllBenefitTestimonials);
}

document.addEventListener('shopify:section:load', function(e) {
  const container = e.target.querySelector('.benefit-testimonials-swiper');
  if (container) initBenefitTestimonialsSwiper(container);
});
